import * as Event_bs$SolvuuApi0 from "./event_bs.bs.js";
import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
import * as Solvuu_job_spec_bs$SolvuuApi0 from "./solvuu_job_spec_bs.bs.js";
var write_spec = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr1("Solvuu", Solvuu_job_spec_bs$SolvuuApi0.write_t, x[1]);
});
var read_spec = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Solvuu",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Solvuu */
      [-522825178, x]
    );
  }, Solvuu_job_spec_bs$SolvuuApi0.read_t, param);
}]],
/* [] */
0]);
var write_validate = Atdgen_codec_runtime.Encode.make(function (x) {
  if (typeof x === "number") {
    return Atdgen_codec_runtime.Encode.constr0("Invalid");
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Valid", write_spec, x[1]);
  }
});
var read_validate = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Valid",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Valid */
      [-991566628, x]
    );
  }, read_spec, param);
}]],
/* :: */
[
/* tuple */
["Invalid",
/* `Single */
[-306849112,
/* Invalid */
144245463]],
/* [] */
0]]);
var write_submit = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr0("Not_implemented");
});
var read_submit = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Not_implemented",
/* `Single */
[-306849112,
/* Not_implemented */
-498198474]],
/* [] */
0]);
var write_backend_status = Atdgen_codec_runtime.Encode.make(function (x) {
  return Atdgen_codec_runtime.Encode.constr0("Not_implemented");
});
var read_backend_status = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Not_implemented",
/* `Single */
[-306849112,
/* Not_implemented */
-498198474]],
/* [] */
0]);
var write_info = Atdgen_codec_runtime.Encode.make(function (x) {
  if (typeof x === "number") {
    return Atdgen_codec_runtime.Encode.constr0("Cancel");
  } else {
    var variant = x[0];

    if (variant >= -307877226) {
      if (variant >= 816044828) {
        return Atdgen_codec_runtime.Encode.constr1("Create", write_spec, x[1]);
      } else {
        return Atdgen_codec_runtime.Encode.constr1("Status_update", write_backend_status, x[1]);
      }
    } else if (variant >= -560624458) {
      return Atdgen_codec_runtime.Encode.constr1("Validate", write_validate, x[1]);
    } else {
      return Atdgen_codec_runtime.Encode.constr1("Submit", write_submit, x[1]);
    }
  }
});
var read_info = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["Create",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Create */
      [816044828, x]
    );
  }, read_spec, param);
}]],
/* :: */
[
/* tuple */
["Validate",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Validate */
      [-560624458, x]
    );
  }, read_validate, param);
}]],
/* :: */
[
/* tuple */
["Submit",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Submit */
      [-828715976, x]
    );
  }, read_submit, param);
}]],
/* :: */
[
/* tuple */
["Cancel",
/* `Single */
[-306849112,
/* Cancel */
-322412134]],
/* :: */
[
/* tuple */
["Status_update",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Status_update */
      [-307877226, x]
    );
  }, read_backend_status, param);
}]],
/* [] */
0]]]]]);
var write_event = Event_bs$SolvuuApi0.write_t;
var read_event = Event_bs$SolvuuApi0.read_t;
var write__1 = Event_bs$SolvuuApi0.write_t(write_info);
var read__1 = Event_bs$SolvuuApi0.read_t(read_info);
var read_solvuu_job_spec = Solvuu_job_spec_bs$SolvuuApi0.read_t;
var write_solvuu_job_spec = Solvuu_job_spec_bs$SolvuuApi0.write_t;
var read_status_update = read_backend_status;
var write_status_update = write_backend_status;
var read_create = read_spec;
var write_create = write_spec;
var read_t = read__1;
var write_t = write__1;
export { read_solvuu_job_spec, write_solvuu_job_spec, read_spec, write_spec, read_validate, write_validate, read_submit, write_submit, read_backend_status, write_backend_status, read_status_update, write_status_update, read_create, write_create, read_info, write_info, read_event, write_event, read_t, write_t };
/* write_spec Not a pure module */